export { default, loader } from "~/components/newsletter/index"

export function LoadingFallback() {
  return <div className='w-full h-[108px] lg:h-[76px] bg-gray-200 animate-pulse' />
}
